import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { usePermission } from '../hooks/usePermission';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Required permission string (e.g., "USER_MGMT_QUERY") */
  permission?: string;
  /** Required module code — checks if user has ANY permission on this module */
  module?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, permission, module }) => {
  const { isAuthenticated, loading } = useAuth();
  const { hasPermission, hasAnyModulePermission, isAdmin } = usePermission();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If a permission or module is required, check it (admins always pass)
  if (!isAdmin && permission && !hasPermission(permission)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="抱歉，您沒有權限訪問此頁面。"
        extra={<Button type="primary" onClick={() => window.history.back()}>返回上一頁</Button>}
      />
    );
  }

  if (!isAdmin && module && !hasAnyModulePermission(module)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="抱歉，您沒有權限訪問此頁面。"
        extra={<Button type="primary" onClick={() => window.history.back()}>返回上一頁</Button>}
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
